import { User } from '../models/user';

const initialUserReducerState: User | null = null;

export const userReducer = (state: User | null = initialUserReducerState): User | null => {
    return state;
};
